(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '.hero--parallax[data-parallax-strength]';
    const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
    const REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');

    let heroes = [];
    let ticking = false;

    function collectHeroes() {
      heroes = Array.from(document.querySelectorAll(SELECTOR));
      requestUpdate();
    }

    function resetHero(hero) {
      hero.style.removeProperty('--hero-parallax-offset');
      hero.style.removeProperty('--hero-parallax-scale');
    }

    function updateParallax() {
      ticking = false;

      if (MOBILE_QUERY.matches || REDUCED_MOTION_QUERY.matches) {
        heroes.forEach(resetHero);
        return;
      }

      const viewportHeight = window.innerHeight;

      heroes.forEach((hero) => {
        const rect = hero.getBoundingClientRect();

        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const strength = Number.parseFloat(hero.dataset.parallaxStrength || '0.18');
        const sectionCenter = rect.top + rect.height / 2;
        const viewportCenter = viewportHeight / 2;
        const distanceFromCenter = sectionCenter - viewportCenter;
        const scale = 1 + strength * 1.25;

          /*
            Limit movement to the extra image area created by scaling.
            The small 4px buffer prevents a thin edge from appearing.
          */
          const availableTravel = Math.max(
            0,
            ((scale - 1) * rect.height) / 2 - 4
          );

          const requestedOffset = distanceFromCenter * strength;

          const offset = Math.max(
            -availableTravel,
            Math.min(availableTravel, requestedOffset)
          );

          hero.style.setProperty(
            '--hero-parallax-offset',
            `${offset.toFixed(2)}px`
          );

          hero.style.setProperty(
            '--hero-parallax-scale',
            scale.toFixed(3)
          );
      });
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    }

    if (!window.__mwcHeroParallaxInitialized) {
      window.__mwcHeroParallaxInitialized = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', collectHeroes);
      } else {
        collectHeroes();
      }

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', collectHeroes);
      document.addEventListener('shopify:section:load', collectHeroes);
      document.addEventListener('shopify:section:unload', collectHeroes);
      document.addEventListener('shopify:section:reorder', collectHeroes);

      MOBILE_QUERY.addEventListener?.('change', collectHeroes);
      REDUCED_MOTION_QUERY.addEventListener?.('change', collectHeroes);
    } else {
      collectHeroes();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const WRAPPER_SELECTOR = '.reusable-scroll-reveal--enabled[data-scroll-reveal-wrapper]';
    const CONTENT_SELECTOR = '[data-testid="section-content"]';

    function revealImmediately(wrapper) {
      wrapper.classList.add('is-visible');
    }

    function initializeScrollReveal(root = document) {
      const wrappers = [];

      if (root.matches?.(WRAPPER_SELECTOR)) {
        wrappers.push(root);
      }

      root.querySelectorAll?.(WRAPPER_SELECTOR).forEach((wrapper) => wrappers.push(wrapper));

      wrappers.forEach((wrapper) => {
        if (wrapper.dataset.scrollRevealInitialized === 'true') return;

        const content = wrapper.querySelector(CONTENT_SELECTOR);
        if (!content) {
          revealImmediately(wrapper);
          return;
        }

        wrapper.dataset.scrollRevealInitialized = 'true';

        wrapper.classList.add('scroll-reveal-ready');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          revealImmediately(wrapper);
          return;
        }

        const observer = new IntersectionObserver(
          (entries, currentObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              revealImmediately(wrapper);
              currentObserver.unobserve(entry.target);
            });
          },
          {
            threshold: 0.24,
            rootMargin: '0px 0px -12% 0px'
          }
        );

        observer.observe(wrapper);
      });
    }

    if (!window.__reusableSectionScrollRevealInitialized) {
      window.__reusableSectionScrollRevealInitialized = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initializeScrollReveal());
      } else {
        initializeScrollReveal();
      }

      document.addEventListener('shopify:section:load', (event) => {
        initializeScrollReveal(event.target);
      });

      document.addEventListener('shopify:section:reorder', () => {
        initializeScrollReveal();
      });

      document.addEventListener('shopify:section:select', (event) => {
        const wrapper = event.target.querySelector?.(WRAPPER_SELECTOR);
        if (!wrapper) return;

        wrapper.classList.remove('is-visible');
        wrapper.dataset.scrollRevealInitialized = 'false';
        initializeScrollReveal(event.target);
      });
    } else {
      initializeScrollReveal();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
